module.exports = __webpack_public_path__ + "img/icon_01@2x.aaf1fe15.png";